export const OFFSET_MEASUREMENT = 2;
export const NORMALIZE_ARROW = 1;
export const OFFSET_MEASUREMENT_TEXT = 1;
export const LABEL_OFFSET = 4.5;
export const COORDS_EPSILON = 10e-3;
export const EDGE_STROKE_WIDTH = 2;
export const MEASUREMENT_STROKE_WIDTH = 0.1;
export const LABEL_STROKE_WIDTH = 0.05;
export const FREE_DRAWER_REAL_TIME_LENGTH_OFFSET = 3;
export const OFFSET_BACKSPLASH = 2.5;

const defaultDrawIcon = 'url("./public/assets/icons/draw.svg") 0 25, default';

export const CANVAS_CURSOR = {
  DEFAULT: {
    DEFAULT: 'default',
    HOVER: 'move',
    DRAW: 'default',
    GRAB: 'GRAB',
    GRABBING: 'GRABBING',
  },
  FREE_DRAWING: {
    DEFAULT: defaultDrawIcon,
    HOVER: defaultDrawIcon,
    DRAW: defaultDrawIcon,
    POINTER: 'url("./public/assets/icons/pointer.svg") 0 25, default',
  },
};
